// Tone-invariant per-hazard safety steps (GUI §3). Returns ordered catalog keys;
// the caller renders them with the i18n catalog so they localize (en complete, other
// locales fall back per t()). Facts/instructions never take the tone slider.
const STEPS: Record<string, string[]> = {
  fire: ["safety.fire.1", "safety.fire.2", "safety.fire.3", "safety.fire.4"],
  flood: ["safety.flood.1", "safety.flood.2", "safety.flood.3", "safety.flood.4"],
  earthquake: ["safety.earthquake.1", "safety.earthquake.2", "safety.earthquake.3", "safety.earthquake.4"],
  conflict: ["safety.conflict.1", "safety.conflict.2", "safety.conflict.3", "safety.conflict.4"],
  other: ["safety.other.1", "safety.other.2", "safety.other.3"],
  traffic: ["safety.traffic.1", "safety.traffic.2", "safety.traffic.3"],
  storm: ["safety.storm.1", "safety.storm.2", "safety.storm.3", "safety.storm.4"],
  snow: ["safety.snow.1", "safety.snow.2", "safety.snow.3"],
  ice: ["safety.ice.1", "safety.ice.2", "safety.ice.3"],
  heat: ["safety.heat.1", "safety.heat.2", "safety.heat.3", "safety.heat.4"],
  fog: ["safety.fog.1", "safety.fog.2", "safety.fog.3"],
  hazmat: ["safety.hazmat.1", "safety.hazmat.2", "safety.hazmat.3"],
  outage: ["safety.outage.1", "safety.outage.2", "safety.outage.3"],
};

export function safetyStepKeys(hazard: string): string[] {
  return STEPS[hazard] ?? STEPS.other;
}
